<template>
    <div>
        <v-container>
            <v-form v-model="valid">
                <v-row>
                    <v-col>
                        <v-dialog v-model="dialogVisible" max-width="500px">
                            <v-card>
                                <v-card-title class="headline">{{dialogTitle}}</v-card-title>
                                <v-card-text>
                                    {{dialogMessage}}
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            color="primary"
                                            text
                                            @click="dialogVisible = false"
                                    >
                                        Close
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col xs="12" lg="9">
                        <v-card>
                            <v-card-title>Order details</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Order ID" v-model="id" readonly dense outlined filled
                                                      height="12"
                                                      :hide-details="auto" class="mb-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="ID at store" v-model="idAtStore" readonly dense outlined
                                                      filled
                                                      height="12"
                                                      :hide-details="auto" class="mb-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Warehouse" v-model="warehouseName" readonly dense outlined
                                                      filled
                                                      height="12"
                                                      :hide-details="auto" class="mb-2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col xs="12" lg="4">
                                        <v-select
                                                :items="statusChoices"
                                                v-model="status"
                                                outlined
                                                dense
                                                label="Status"
                                        ></v-select>
                                    </v-col>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Order date" v-model="createdAt" dense outlined readonly
                                                      filled
                                                      class="mb-2" :hide-details="auto"></v-text-field>
                                    </v-col>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Website" v-model="this.store.name" dense outlined readonly
                                                      filled
                                                      class="mb-2" :hide-details="auto"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Original Estimated Delivery Date"
                                                      v-model="this.originalEstimatedDeliveryDate" dense outlined
                                                      readonly
                                                      filled
                                                      class="mb-2" :hide-details="auto"></v-text-field>
                                    </v-col>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Actual Estimated Delivery Date"
                                                      v-model="this.actualEstimatedDeliveryDate" dense outlined readonly
                                                      filled
                                                      class="mb-2" :hide-details="auto"></v-text-field>
                                    </v-col>
                                    <v-col xs="12" lg="4">
                                        <v-text-field label="Payment method" v-model="this.paymentMethod" dense outlined
                                                      readonly
                                                      filled
                                                      class="mb-2" :hide-details="auto"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-col xs="12" lg="2">
                                <v-btn color="primary" class="d-flex .justify-end" @click="saveOrderData">Save</v-btn>
                            </v-col>
                        </v-card>
                    </v-col>
                    <!--
                    <v-col xs="12" lg="3">
                        <v-card>
                            <v-card-title>
                                Status history
                            </v-card-title>
                        </v-card>
                    </v-col>
                    -->
                </v-row>
                <v-row>
                    <v-col xs="12" lg="3">
                        <v-card>
                            <v-card-title>
                                Customer details
                            </v-card-title>
                            <v-card-text>
                                <v-text-field label="First name" v-model="customerDetails.firstName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Middle name" v-model="customerDetails.middleName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Last name" v-model="customerDetails.lastName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Phone number" v-model="customerDetails.phone" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Email" v-model="customerDetails.email" dense outlined
                                              :hide-details="auto"></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col xs="12" lg="3">
                        <v-card>
                            <v-card-title>
                                Delivery address
                            </v-card-title>
                            <v-card-text>
                                <v-text-field label="First name" v-model="deliveryAddress.firstName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Last name" v-model="deliveryAddress.lastName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Company" v-model="deliveryAddress.companyName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Phone number" v-model="deliveryAddress.phone" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Email" v-model="deliveryAddress.email" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-textarea label="Street" v-model="deliveryAddress.street" dense outlined
                                            class="mb-2" :hide-details="auto" rows="3"></v-textarea>
                                <v-text-field label="Postcode" v-model="deliveryAddress.postcode" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Town" v-model="deliveryAddress.town" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Country" v-model="deliveryAddress.country" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col xs="12" lg="3">
                        <v-card>
                            <v-card-title>
                                Billing address
                            </v-card-title>
                            <v-card-text>
                                <v-text-field label="First name" v-model="billingAddress.firstName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Last name" v-model="billingAddress.lastName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Company" v-model="billingAddress.companyName" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Phone number" v-model="billingAddress.phone" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Email" v-model="billingAddress.email" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-textarea label="Street" v-model="billingAddress.street" dense outlined
                                            class="mb-2" :hide-details="auto" rows="3"></v-textarea>
                                <v-text-field label="Postcode" v-model="billingAddress.postcode" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Town" v-model="billingAddress.town" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                                <v-text-field label="Country" v-model="billingAddress.country" dense outlined
                                              class="mb-2" :hide-details="auto"></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col xs="12" lg="9">
                        <v-card>
                            <v-card-title>
                                Order items
                            </v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left">SKU</th>
                                            <th class="text-left">Name</th>
                                            <th class="text-left">Option</th>
                                            <th class="text-left">QTY</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="orderItem in orderItems" :key="orderItem.idAtStore">
                                            <td>
                                                <v-text-field v-model="orderItem.item" dense
                                                              outlined
                                                              height="12"
                                                              :hide-details="auto" class="mb-2"
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field v-model="orderItem.itemName" readonly dense filled
                                                              outlined
                                                              height="12"
                                                              :hide-details="auto" class="mb-2"
                                                ></v-text-field>
                                            </td>
                                            <td v-if="orderItem.item === 'PLATES'">
                                                <v-text-field v-model="orderItem.attribute" dense
                                                              outlined
                                                              height="12"
                                                              :hide-details="auto" class="mb-2"
                                                ></v-text-field>
                                            </td>
                                            <td v-else>
                                                <v-text-field v-model="orderItem.attribute" readonly dense filled
                                                              outlined
                                                              height="12"
                                                              :hide-details="auto" class="mb-2"
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field v-model="orderItem.quantity" readonly dense filled
                                                              outlined
                                                              height="12"
                                                              :hide-details="auto" class="mb-2"
                                                ></v-text-field>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                            <div class="d-flex flex-row-reverse">
                                <v-simple-table dense>
                                    <tbody>
                                    <tr>
                                        <td>Subtotal:</td>
                                        <td><span v-html="currencySymbol"></span>{{this.subtotalValue}}</td>
                                    </tr>
                                    <tr>
                                        <td>Shipping:</td>
                                        <td><span v-html="currencySymbol"></span>{{this.shippingValue}}</td>
                                    </tr>
                                    <tr>
                                        <td>Tax:</td>
                                        <td><span v-html="currencySymbol"></span>{{this.taxValue}}</td>
                                    </tr>
                                    <tr>
                                        <td>Total:</td>
                                        <td><span v-html="currencySymbol"></span>{{this.totalValue}}</td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col xs="12" lg="9">
                        <v-card>
                            <v-card-title>
                                Delivery information
                            </v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Tracking number</th>
                                                <th class="text-left">Dispatch date</th>
                                                <th class="text-left">Courier</th>
                                                <th class="text-left">Estimated delivery date</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="trackingDetail in trackingDetails"
                                                :key="trackingDetail.trackingNumber">

                                                <td>
                                                    <v-text-field v-model="trackingDetail.trackingNumber" dense
                                                                  outlined
                                                                  height="12"
                                                                  :hide-details="auto" class="mb-2"
                                                    ></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field v-model="trackingDetail.dispatchedAt" dense
                                                                  outlined
                                                                  height="12"
                                                                  :hide-details="auto" class="mb-2"
                                                    ></v-text-field>
                                                </td>
                                                <td>
                                                    <v-select
                                                            :items="courierChoices"
                                                            v-model="trackingDetail.courier"
                                                            outlined
                                                            dense
                                                    ></v-select>
                                                </td>
                                                <td>
                                                    <v-text-field v-model="trackingDetail.expectedDeliveryDate" readonly
                                                                  dense filled
                                                                  outlined
                                                                  height="12"
                                                                  :hide-details="auto" class="mb-2"
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <v-btn  color="primary" class="d-flex .justify-end" dense @click="addEmptyTrackingDetail">Add tracking details</v-btn>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col xs="12" lg="9">
                        <v-card>
                            <v-card-title>
                                Comments
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col xs="6" lg="2">
                                        <v-text-field label="Comment update time" v-model="commentDateTime" readonly
                                                      dense outlined filled
                                                      height="12"
                                                      :hide-details="auto" class="mb-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col xs="12" lg="7">
                                        <v-textarea label="Comment" v-model="comment" dense outlined
                                                    class="mb-2" :hide-details="auto" rows="8"
                                                    placeholder="Write your comment here"></v-textarea>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>

  import {getCookie} from '@/helpers/getCookie.js'
  import {getFormattedDate, getFormattedDateTime} from '@/helpers/dateFormatters.js'

  const axios = require('axios')
  export default {
    name: "OrderDetails",
    components: {},
    data() {
      return {
        valid: false,
        id: "",
        idAtStore: "",
        status: "",
        createdAt: "",
        warehouseName: "",
        currency: "",
        totalValue: "",
        subtotalValue: "",
        taxValue: "",
        shippingValue: "",
        comment: "",
        commentDateTime: "",
        dialogVisible: false,
        dialogTitle: "",
        dialogMessage: "",
        actualEstimatedDeliveryDate: "",
        originalEstimatedDeliveryDate: "",
        paymentMethod: "",
        statusChoices: [],
        courierChoices: [],
        customerDetails: {
          firstName: "",
          middleName: "",
          lastName: "",
          companyName: "",
          phone: "",
          email: "",
        },
        deliveryAddress: {
          firstName: "",
          lastName: "",
          companyName: "",
          phone: "",
          email: "",
          street: "",
          town: "",
          postcode: "",
          country: "",
        },
        billingAddress: {
          firstName: "",
          lastName: "",
          companyName: "",
          phone: "",
          email: "",
          street: "",
          town: "",
          postcode: "",
          country: "",
        },
        orderItems: [],
        trackingDetails: [],
        store: {
          name: "",
          platform: "",
        }
      }
    },
    mounted() {
      this.getChoicesValues()
      this.getOrderData()
    },
    computed: {
      currencySymbol: function () {
        if (this.currency === "EUR") {
          return "&euro;"
        } else {
          return "&pound;"
        }
      }
    },
    methods: {
      getOrderData() {
        let redirectFunction = this.redirectToLogin
        let orderId = this.$route.params.id
        axios.get("/api/orders/" + orderId + "/", {
          headers: {
            Authorization: "Token " + this.$store.getters.authToken
          }
        }).then(this.setOrderData).catch(function (error) {
          console.log(error)
          if (403 === error.response.status) {
            alert("Failed to obtain data")
            redirectFunction()
          } else {
            this.dialogTitle = "Failed to load order"
            this.dialogMessage = "Failed to get order data, check console for details"
            this.dialogVisible = true
          }
        })
      },
      setOrderData(response) {
        this.id = response.data.id
        this.idAtStore = response.data.id_at_store
        this.status = response.data.status
        this.createdAt = getFormattedDateTime(response.data.created_at)
        this.warehouseName = response.data.warehouse_name
        this.paymentMethod = response.data.payment_method_human_name

        this.actualEstimatedDeliveryDate = getFormattedDate(response.data.actual_estimated_delivery_date)
        this.originalEstimatedDeliveryDate = getFormattedDate(response.data.original_estimated_delivery_date)

        this.customerDetails.firstName = response.data.customer_details.first_name
        this.customerDetails.middleName = response.data.customer_details.middle_name
        this.customerDetails.lastName = response.data.customer_details.last_name
        this.customerDetails.companyName = response.data.customer_details.company_name
        this.customerDetails.phone = response.data.customer_details.phone
        this.customerDetails.email = response.data.customer_details.email

        this.deliveryAddress.firstName = response.data.delivery_address.first_name
        this.deliveryAddress.middleName = response.data.delivery_address.middle_name
        this.deliveryAddress.lastName = response.data.delivery_address.last_name
        this.deliveryAddress.companyName = response.data.delivery_address.company_name
        this.deliveryAddress.phone = response.data.delivery_address.phone
        this.deliveryAddress.email = response.data.delivery_address.email
        this.deliveryAddress.street = response.data.delivery_address.street
        this.deliveryAddress.town = response.data.delivery_address.town
        this.deliveryAddress.postcode = response.data.delivery_address.postcode
        this.deliveryAddress.country = response.data.delivery_address.country

        this.billingAddress.firstName = response.data.billing_address.first_name
        this.billingAddress.middleName = response.data.billing_address.middle_name
        this.billingAddress.lastName = response.data.billing_address.last_name
        this.billingAddress.companyName = response.data.billing_address.company_name
        this.billingAddress.phone = response.data.billing_address.phone
        this.billingAddress.email = response.data.billing_address.email
        this.billingAddress.street = response.data.billing_address.street
        this.billingAddress.town = response.data.billing_address.town
        this.billingAddress.postcode = response.data.billing_address.postcode
        this.billingAddress.country = response.data.billing_address.country

        this.store.name = response.data.store.name
        this.store.platform = response.data.store.platform
        this.currency = response.data.currency
        this.totalValue = response.data.total_value
        this.subtotalValue = response.data.subtotal_value
        this.taxValue = response.data.tax_value
        this.shippingValue = response.data.shipping_value

        this.comment = response.data.comment
        this.commentDateTime = getFormattedDateTime(response.data.comment_update_datetime)

        this.orderItems = []
        for (var i = 0; i < response.data.items.length; i++) {
          var orderItem = response.data.items[i];
          var itemData = {
            item: orderItem.item,
            quantity: orderItem.quantity,
            idAtStore: orderItem.id_at_store,
            itemName: orderItem.item_name,
            attribute: orderItem.attribute,
          }
          this.orderItems.push(itemData)
        }

        this.trackingDetails = []
        for (var j = 0; j < response.data.tracking_details.length; j++) {
          var trackingDetail = response.data.tracking_details[j];
          var mappedTrackingDetail = {
            trackingNumber: trackingDetail.tracking_number,
            dispatchedAt: trackingDetail.dispatched_at,
            courierName: trackingDetail.courier_name,
            courier: trackingDetail.courier,
            expectedDeliveryDate: trackingDetail.expected_delivery_date,
          }
          this.trackingDetails.push(mappedTrackingDetail)
        }
      },
      redirectToLogin() {
        this.$router.push({name: 'login'})
      },
      saveOrderData() {
        var itemsData = []
        var trackingDetails = []
        this.dialogTitle = "Saving order..."
        this.dialogMessage = "Save in progress"
        this.dialogVisible = true

        for (var i = 0; i < this.orderItems.length; i++) {
          var orderItem = this.orderItems[i];
          var itemData = {
            item: orderItem.item,
            quantity: orderItem.quantity,
            id_at_store: orderItem.idAtStore,
            attribute: orderItem.attribute,
          }
          itemsData.push(itemData)
        }

        for (var j = 0; j < this.trackingDetails.length; j++) {
          var trackingDetail = this.trackingDetails[j];
          var trackingDetailData = {
            tracking_number: trackingDetail.trackingNumber,
            dispatched_at: trackingDetail.dispatchedAt,
            courier: trackingDetail.courier,
          }
          trackingDetails.push(trackingDetailData)
        }

        var orderData = {
          status: this.status,
          comment: this.comment,
          customer_details: {
            first_name: this.customerDetails.firstName,
            middle_name: this.customerDetails.middleName,
            last_name: this.customerDetails.lastName,
            phone: this.customerDetails.phone,
            email: this.customerDetails.email,
          },
          billing_address: {
            first_name: this.billingAddress.firstName,
            last_name: this.billingAddress.lastName,
            company_name: this.billingAddress.companyName,
            phone: this.billingAddress.phone,
            email: this.billingAddress.email,
            street: this.billingAddress.street,
            town: this.billingAddress.town,
            postcode: this.billingAddress.postcode,
            country: this.billingAddress.country
          },
          delivery_address: {
            first_name: this.deliveryAddress.firstName,
            last_name: this.deliveryAddress.lastName,
            company_name: this.deliveryAddress.companyName,
            phone: this.deliveryAddress.phone,
            email: this.deliveryAddress.email,
            street: this.deliveryAddress.street,
            town: this.deliveryAddress.town,
            postcode: this.deliveryAddress.postcode,
            country: this.deliveryAddress.country
          },
          items: itemsData,
          tracking_details: trackingDetails,
        }
        let redirectFunction = this.redirectToLogin
        let orderId = this.$route.params.id
        var url = "/api/orders/" + orderId + "/"

        axios.patch(url, orderData, {
          headers: {
            //Authorization: "Token " + this.$store.getters.authToken,
            "X-CSRFToken": getCookie("csrftoken")
          },
        }).then(this.processOrderSaved).catch(function (error) {
          if (403 === error.response.status) {
            alert("Failed to obtain data")
            redirectFunction()
          } else {
            console.log(error)
            this.dialogTitle = "Failed to save order"
            this.dialogMessage = "Failed to save order, check browser console for details"
            this.dialogVisible = true
          }
        })
      },
      getChoicesValues() {
        let redirectFunction = this.redirectToLogin
        axios.options("/api/orders/", {
          headers: {
            Authorization: "Token " + this.$store.getters.authToken
          }
        }).then(this.setChoicesValues).catch(function (error) {
          if (403 === error.response.status) {
            alert("Failed to obtain data")
            redirectFunction()
          }
        })
      },
      setChoicesValues(response) {
        var statusChoices = response.data.actions.POST.status.choices
        var parsedStatusChoices = []
        for (var i = 0; i < statusChoices.length; i++) {
          var choice = statusChoices[i]
          var parsedChoice = {
            text: choice.display_name,
            value: choice.value,
          }
          parsedStatusChoices.push(parsedChoice)
        }
        this.statusChoices = parsedStatusChoices

        // move to other method
        var courierChoices = response.data.actions.POST.tracking_details.child.children.courier.choices
        var parsedCourierChoices = []
        for (var j = 0; j < courierChoices.length; j++) {
          var courierChoice = courierChoices[j]
          var parsedCourierChoice = {
            text: courierChoice.display_name,
            value: courierChoice.value,
          }
          parsedCourierChoices.push(parsedCourierChoice)
        }
        this.courierChoices = parsedCourierChoices
      },
      processOrderSaved() {
        this.dialogTitle = "Order saved"
        this.dialogMessage = "OK"
        this.dialogVisible = true
        this.getOrderData()
      },
      addEmptyTrackingDetail() {
        var emptyTrackingDetail = {
          trackingNumber: "",
          dispatchedAt: "",
          courier: "",
          expectedDeliveryDate: "",
        }
        this.trackingDetails.push(emptyTrackingDetail)
      }

    }
  }
</script>

<style scoped>

</style>